import { Component, ChangeDetectorRef, AfterViewChecked, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { NavigationService } from "src/app/services/NavigationService.service";
import { Subscription } from "rxjs";
import { AdminMenuItem } from "./admin-menu-item.component";

enum menuItemsSlug {
  menageUsers = "users-management",
  managePricing = "manage-pricing",
  accountSetup = "wl-configuration"
}

export class AdminMenuStructure {
  private readonly navigationService: NavigationService = new NavigationService();
  private adminMenuItems: Array<AdminMenuItem> = [];

  constructor(
    private readonly wlSlug: string,
  ) {
    this.adminMenuItems.push(new AdminMenuItem(
      "Manage users",
      "assets/images/manage_users.svg",
      this.navigationService.adminUsers,
      menuItemsSlug.menageUsers
    ));
    this.adminMenuItems.push(new AdminMenuItem(
      "Settings",
      "assets/images/account_setup.svg",
      this.navigationService.adminAccountSetup,
      menuItemsSlug.accountSetup
    ));
  }

  public getMenuItems() {
    return this.adminMenuItems;
  }

  public addManagePricingMenuItem() {
    const exists = this.adminMenuItems.some((i) => i.slug === menuItemsSlug.managePricing);
    if (exists) return;

    const item = new AdminMenuItem(
      "Manage pricing",
      "assets/images/dolar-icon.svg",
      this.navigationService.adminManagePriceFactor,
      menuItemsSlug.managePricing
    );
    
    this.adminMenuItems.splice(1, 0, item);
  }

  public removeManagePricingMenuItem() {
    this.adminMenuItems = this.adminMenuItems.filter((i) => i.slug !== menuItemsSlug.managePricing);
  }
}

@Component({
  selector: "app-admin-view",
  templateUrl: "./admin-view.component.html",
  styleUrls: ["./admin-view.component.scss"]
})
export class AdminViewComponent implements AfterViewChecked, OnDestroy {
  public menuStructure: AdminMenuStructure;
  static readonly manageUsersTabMenu = menuItemsSlug.menageUsers;
  static readonly accountSetupTabMenu = menuItemsSlug.accountSetup;
  static readonly managePricingTabMenu = menuItemsSlug.managePricing;
  public isTopNavbarInfoVisible = false;
  private childDataSubscription?: Subscription;

  constructor(
    private adminService: AdminService,
    private router: Router,
    private route: ActivatedRoute,
    private changeDetector: ChangeDetectorRef
  ) {
    this.menuStructure = this.adminService.menuStructure;
    const child = this.route.firstChild;
    if (child) {
      this.childDataSubscription = child.data.subscribe((extraData) => {
        if (extraData && extraData.menuTab)
          this.adminService.setActiveTab(extraData.menuTab);
      });
    }
  }

  ngAfterViewChecked() {
    this.changeDetector.detectChanges();
  }

  ngOnDestroy(): void {
    if (this.childDataSubscription) this.childDataSubscription.unsubscribe();
  }

  public changeActiveTab(item: AdminMenuItem): void {
    this.adminService.setActiveTab(item.slug);
    
    this.router.navigate([item.navigateTo]);
  }

}
